import { initializeApp } from 'firebase/app';
import { getFirestore, getDocs, collection } from 'firebase/firestore';
import {
  initializeAuth,
  browserPopupRedirectResolver,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithRedirect,
  onAuthStateChanged
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyB_oo4HZ2Q2H56GOPj6K-jX5tBz5L7EqYA",
  authDomain: "clases-c74fb.firebaseapp.com",
  projectId: "clases-c74fb",
  storageBucket: "clases-c74fb.firebasestorage.app",
  messagingSenderId: "47453211575",
  appId: "1:47453211575:web:fb4583fd9cd9fdb3347632",
  measurementId: "G-HR5MWG3G2Q"
};

// Инициализация приложения Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Постоянство сессии задаём здесь, при создании auth, а не через асинхронный
// setPersistence() в компонентах. Раньше App и BookingCalendar вызывали
// setPersistence(browserLocalPersistence) при каждом монтировании: это
// переключало хранилище с IndexedDB на localStorage и на время переезда
// удаляло запись о пользователе. Теперь порядок хранилищ фиксирован сразу:
// IndexedDB (более надёжное хранилище, штатный выбор SDK) с откатом на
// localStorage там, где IndexedDB недоступен (приватные окна части браузеров).
const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence],
  popupRedirectResolver: browserPopupRedirectResolver,
});

// Экспортируем необходимые функции
const googleProvider = new GoogleAuthProvider();

export {
  app,
  db,
  auth,
  googleProvider,  getDocs,  // Добавлено
  collection,  // Добавлено
  signInWithPopup,
  signOut,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signInWithRedirect
};
